import Color from '../Color.js';
import mix from '../generator/mix.js';
Color.prototype.mix = Color.prototype.interpolate = function (col2) {
  var f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }
  return mix.apply(void 0, [this, col2, f].concat(rest));
};